export default "__VITE_ASSET__DD8m1Wny__"